// extracted by mini-css-extract-plugin
module.exports = {"root":"selection-card-body-content-description_root__hgG8d"};